// Privacy.jsx
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { TranslationNamespace } from '../resource/translationNamespace.js';
import { NULL_FUNCTION } from '../resource/defaults.js';
import { LegalPageLayout } from '../component/LegalPageLayout.jsx';

const Privacy = ({
  t,
  goBack = NULL_FUNCTION,
  handleMailTo = NULL_FUNCTION,
}) => (
  <LegalPageLayout
    title={t('seo_privacy_policy_h1', { ns: TranslationNamespace.SEO })}
    htmlString={t('privacy_policy_seo_description', {
      ns: TranslationNamespace.SETTINGS,
      interpolation: { prefix: '#__NONE__#', suffix: '#__NONE__#' },
    })}
    goBack={goBack}
    onMailTo={handleMailTo}
  />
);

Privacy.propTypes = {
  goBack: PropTypes.func,
  handleMailTo: PropTypes.func,
  t: PropTypes.func.isRequired,
};

export { Privacy };
export default withTranslation()(memo(Privacy));
